import { configureStore } from '@reduxjs/toolkit';
import { activitiesReducer } from './slices/activities';
import { reviewsReducer } from './slices/reviews';
import { authReducer } from './slices/auth';
import { servicesReducer } from './slices/services';
import { leadsReducer } from './slices/leads';
import { requestFormReducer } from './slices/requestForm';
import { aboutReducer } from './slices/about';

const store = configureStore({
    reducer: {
        activities: activitiesReducer,
        reviews: reviewsReducer,
        auth: authReducer,
        services: servicesReducer,
        leads: leadsReducer,
        requestForm: requestFormReducer,
        about: aboutReducer,
    }
});

export default store;